// Central place to edit copy & links. The PayPal link is a placeholder — replace with the real URL.
export const SITE = {
  name: "Rewire and Root",
  tagline: "Understanding your nervous system in a stress-filled world",
  price: 397,
  priceLabel: "$397",
  email: "contact@rewireandroot.com",
  paypalUrl: "https://www.paypal.com/paypalme/aimeepage16/397",
  instructor: {
    name: "Aimee Page, MS LPC NCC",
    shortName: "Aimee Page",
    title: "Licensed Board Certified Psychotherapist",
    credentials:
      "MS, LPC, NCC — Master’s in Trauma Counseling, Thomas Jefferson University",
  },
  course: {
    weeks: 6,
    format: "Once weekly, live online sessions",
    startDate: "June 22",
    startDateLong: "Next cohort begins June 22",
  },
};

export const NAV = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/curriculum", label: "Curriculum", testid: "nav-curriculum-link" },
  { to: "/enroll", label: "Enroll", testid: "nav-enroll-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const DISCLAIMER_SHORT =
  "This course is educational and is not therapy, medical or mental-health treatment, or a substitute for either.";

export const DISCLAIMER_LONG =
  "Aimee Page is a licensed board-certified psychotherapist. Rewire and Root is an educational and skill-building program designed to help participants better understand their nervous systems. It is not a substitute for psychotherapy, medical care, diagnosis, or treatment, and no therapeutic relationship is formed by participating. If you are in crisis or in need of clinical care, please contact a licensed professional in your jurisdiction or, in an emergency, dial 911 or your local emergency services.";
